import React from 'react';
import { isNaNish } from 'helpers/balances';
import buildTradeId from 'helpers/buildTradeId';
import { useWSHook } from '../useWSHook';
import fetchInitDataToRawData from './fetchInitDataToRawData';

export default function useWSTradeHistory(pair, wsHook, limit = 50) {
  const rawDataUniqBy = 'tradeId';

  const processWSEventDataToRawData = React.useCallback(
    (eventData, currentRawData, outOfOrderEventsData = []) => {
      const newRawData = [...currentRawData];

      if (eventData.type === 'TRADE-CREATED') {
        // remap to same format as HTTP response
        const remappedData = {
          tradeId: buildTradeId(eventData.data.maker.id, eventData.data.taker.id),
          price: eventData.data.price,
          quantity: eventData.data.quantity,
          takerOrder: eventData.data.taker,
          makerOrder: eventData.data.maker,
          createdAt: eventData.data.timestamp
        };
        newRawData.unshift(remappedData);
      } else {
        console.warn(`Unexpected event for WS Trade history: `, eventData);
      }

      return {
        newRawData,
        newOutOfOrderEvents: outOfOrderEventsData // do nothing
      };
    },
    []
  );

  const processRawData = React.useCallback(
    rawData => {
      let price;
      if (rawData.length > 0) {
        rawData = rawData.slice(0, limit);
        [{ price }] = rawData;
      }
      const marketPrice = !isNaNish(price) ? Number(price) : null;

      return {
        body: rawData,
        marketPrice
      };
    },
    [limit]
  );

  const processMessageConditions = React.useCallback(eventData => {
    return eventData.type === 'TRADE-CREATED';
  }, []);

  const fetchInitDataToRawDataWithPair = React.useCallback(
    () => fetchInitDataToRawData(pair, limit),
    [pair, limit]
  );

  const initialProcessedDataState = {};

  return useWSHook({
    wsHook,
    processMessageConditions,
    rawDataUniqBy,
    processRawData,
    processWSEventDataToRawData,
    fetchInitDataToRawData: fetchInitDataToRawDataWithPair,
    initialProcessedDataState
  });
}
